import { ChangeEvent } from 'react';
import { useSyncState } from 'src/hooks';
import { useUserRoles } from 'src/auth';
import { useParams } from 'react-router-dom';
import { SolutionMenderSettings, SolutionType } from '../types';
import { getSolutionSettingsMenderFormFields } from './formFields';
import { useSolutionUserRoles } from '../hooks';

export const useSolutionSettingsMenderFormFields = (
  item?: SolutionMenderSettings
) => {
  const [menderEnabled, setMenderEnabled] = useSyncState(item?.menderEnabled, [
    item?.menderEnabled,
  ]);
  const onMenderEnabledChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    setMenderEnabled(target.checked);
  };

  const { isPlatformReader } = useUserRoles();
  const { solutionType, solutionId } = useParams();
  const isConsumerSolution = solutionType === SolutionType.Consumer;
  const { isValidSolutionUser } = useSolutionUserRoles(solutionId);
  return getSolutionSettingsMenderFormFields(
    menderEnabled,
    isPlatformReader,
    isValidSolutionUser,
    isConsumerSolution,
    onMenderEnabledChange
  );
};
